import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getConferences } from '../../actions/conference';
import ConferenceItem from './ConferenceItem';


const AllConferences = ({
  auth,
  getConferences,
  conference: {conferences},
}) => {

  useEffect(() => {
    getConferences();
  }, [getConferences]);

  return (
    <div className='container'>
    <Row xs={1} md={3} className="g-4">
        {conferences.map(conference => (
            <ConferenceItem key={conference._id} conference={conference} />
        ))}
    </Row>
    </div>
  )
};

AllConferences.propTypes = {
  getConferences: propTypes.func.isRequired,
  conference: propTypes.object.isRequired,
  auth: propTypes.object.isRequired
};

const mapStateToProps = state => ({
  conference: state.conference,
  auth: state.auth
});

export default connect(mapStateToProps, { getConferences })(AllConferences);